
const deep_copy = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const obj_eq = (obj_a, obj_b) => {
  return JSON.stringify(obj_a) === JSON.stringify(obj_b);
}

/**
 * obj[path_0][path_1][...] = value
 * @param obj Object
 * @param path [String]
 * @param value Object
 */
const deep_assign = (obj, path, value) => {
  let lastKeyIndex = path.length-1;
  for (let i = 0; i < lastKeyIndex; i++) {
    let key = path[i];
    if (!(key in obj)){
      obj[key] = {}
    }
    obj = obj[key];
  }
  obj[path[lastKeyIndex]] = value;
};

/**
 * @param obj {Object}
 * @param path {[String]}
 * @param value {Object} Can't be a constant, have to be an object.
 */
const deep_update = (obj, path, value) => {
  for (let i = 0; i < path.length; i++) {
    let key = path[i];
    if (!(key in obj)){
      obj[key] = {}
    }
    obj = obj[key];
  }
  Object.assign(obj, value);
};

const path_exists = (obj, path) => {
  let result = true;
  for(let i=0; i < path.length; i++) {
    const key = path[i];

    if (!(key in obj)) {
      result = false;
      break;
    }
    obj = obj[key];
  }
  return result;
}

// Recursively descend obj. When you find { obj: prop }, return the path.
// Else return null
const deep_find = (obj, prop, value, path=[]) => {

  const local_props = Object.keys(obj);
  for(let i=0 ; i < local_props.length; i++) {
    const curr_prop = local_props[i];
    if (curr_prop === prop && obj[curr_prop] === value) {
      return [curr_prop];
    } else if (typeof obj[curr_prop] === "object") {
      let result = deep_find(obj[curr_prop], prop, value);
      if (Array.isArray(result)) {
        return [curr_prop].concat(result);
      }
    }
  }
  return null;
}

/**
 * A comparison function for sorting strings.
 * @param a_str {String}
 * @param b_str {String}
 * @return {int}
 */
const string_cmp = (a_str, b_str) => {
  if (a_str > b_str) {
    return 1;
  }
  if (a_str < b_str) {
    return -1;
  }
  return 0;
};


module.exports = {
  deep_copy, obj_eq, deep_assign, deep_update, path_exists, deep_find,
  string_cmp,
}
